import React, { useLayoutEffect, useState } from "react";

import ReactDOM from "react-dom";

// Имена слотов держим здесь, чтобы у портала и у самой шапки был один источник имени.
export const PAGE_TITLE_SLOT_ID = "page-header-title";
export const PAGE_HEADER_ACTIONS_SLOT_ID = "page-header-actions";

interface HeaderSlotProps {
    slotId: string;
    children: React.ReactNode;
}

/*
* Переносит часть страницы в шапку приложения (layouts/Header), не вынимая её из
* React-дерева самой страницы: портал сохраняет контекст, поэтому содержимое видит состояние
* экрана (счётчики, диалоги, данные фичи). Передать узел через стор так не выйдет — он
* отрендерится внутри Header и до контекста страницы не дотянется.
* */
export const HeaderSlot = ({ slotId, children }: HeaderSlotProps) => {
    const [slot, setSlot] = useState<HTMLElement | null>(null);

    // useLayoutEffect, а не useEffect: слот ищется до отрисовки, иначе содержимое успевает
    // мигнуть на своём месте в потоке страницы и только потом переезжает в шапку.
    useLayoutEffect(() => {
        setSlot(document.getElementById(slotId));
    }, [slotId]);

    if (!slot) return null;

    return ReactDOM.createPortal(children, slot);
};
